import { Component } from '@angular/core';
import {  OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';

import { Subscription,Observable } from 'rxjs/Rx';

import { TranslateService } from '@ngx-translate/core';

import { RootService } from '../../../service/root.service';

import { Project } from '../shared/project';
import { ProjectService } from '../shared/project.service';

import { ConfirmationService } from 'primeng/primeng';

import { enDefualt, arDefualt } from '../../../shared/config';
import * as moment from 'moment';

@Component({
    selector: 'projects',
    templateUrl: './projects.component.html',
    styleUrls: ['./projects.component.scss']
})
export class ProjectsComponent implements OnInit, OnDestroy {

    @Input() selectedProject;
    @Output() selectedProjectChange = new EventEmitter();
    @Input() operation: string;
    fromRoute: boolean;

    projects: Project[];
    


    routeEvent: Subscription;
    requestXHR: Subscription;
    requestError: boolean;
    noResult: boolean;

    constructor(public rootService: RootService,
        public projectService: ProjectService,
        public route: ActivatedRoute,
        public router: Router,
        public confirmationService: ConfirmationService,
        public translate: TranslateService) {
            translate.onLangChange.subscribe((event) => {
                this.translateList();
            });

    }

    dateSort(event, DateField) {

        let comparer = function (a, b): number {
            let result: number = -1;

            if (a[DateField].ms > b[DateField].ms) result = 1;
            return result * event.order;
        };

        this.projects.sort(comparer);
    }

    translateList(){
        
    }

    getProjects() {
        this.projects = null;
        this.requestError = false;
        this.noResult = false;
        if (this.requestXHR) {
            this.requestXHR.unsubscribe();
        }
        this.requestXHR = this.projectService.getAll()
            .subscribe(
            items => {
                if (items.projects.length == 0) {
                    this.projects = [];
                    this.noResult = true;
                } else {
                    this.projects = items.projects;
                    this.translateList();
                }
                


            },
            err => {
                this.requestError = true;
                this.rootService.toast.showErrorCode(err.code);
            });
    }
    getProject(project, operation) {

        if (operation == 'edit') {
            this.router.navigateByUrl('admin/project/' + project._id + '/update');
        } else if (operation == 'clone') {
            this.router.navigateByUrl('admin/project/' + project._id + '/clone');
        } else {
            this.router.navigate(['admin/project', project._id]);
        }



    }
    emitProject(project) {
        this.selectedProject = project;
        this.selectedProjectChange.emit(this.selectedProject);
    }
    deleteProject(id: number) {
        this.confirmationService.confirm({
            message: this.translate.instant('form.common.deleteQ', { 'item': this.translate.instant('ctrl.project.view.header.one') }),
            header: this.translate.instant('form.common.delete'),
            icon: 'fa fa-trash',
            accept: () => {
                this.projectService.delete(id)
                    .subscribe(
                    items => {
                        this.projects = this.projects.filter(project => project._id !== id);
                        this.rootService.toast.showSuccess(this.translate.instant('form.common.deleteItem', { 'item': this.translate.instant('ctrl.project.view.header.one') }));
                    }, //Bind to view
                    err => {
                        this.rootService.toast.showErrorCode(err.code);
                    });
            }
        });

    }
    ngOnInit() {


        this.getProjects();

    }

    ngOnDestroy() {
        if (this.requestXHR) {
            this.requestXHR.unsubscribe();
        }
        if (this.routeEvent) {
            this.routeEvent.unsubscribe();
        }

    }
}



// WEBPACK FOOTER //
// ./src/app/module/project/projects/projects.component.ts